import PropTypes from 'prop-types';
import React from 'react';
import classSet from 'classnames';

// styles
import css from './input.sss';

export const Input = (props) => {
    const fieldClasses = classSet(
        css.field,
        {
            [css.stateError]: props.error,
            [css.stateDisabled]: props.disabled,
        }
    );

    return (
        <div>
            <div className={css.root}>
                <input
                    className={fieldClasses}
                    autoFocus={props.autoFocus}
                    autoComplete={props.autoComplete}
                    name={props.name}
                    ref={props.refFn}
                    type={props.type}
                    id={props.id}
                    maxLength={props.maxLength}
                    value={props.value}
                    defaultValue={props.defaultValue}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    onChange={props.onChange}
                    onFocus={props.onFocus}
                    onBlur={props.onBlur}
                    onKeyDown={props.onKeyDown}
                    data-qaid={props.dataQa}
                />
            </div>
        </div>
    );
};


Input.propTypes = {
    error: PropTypes.bool,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.string,
    maxLength: PropTypes.string,
    onKeyDown: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    refFn: PropTypes.func,
    dataQa: PropTypes.string,
};

Input.defaultProps = {
    type: 'text',
};
